export default "__VITE_ASSET__DFdzPnKS__"